'use strict';

angular.module('TurneroApp').component('coTasasDetalles', {
    bindings: {
        usuario: '<'
    },
    controller: [
        '$window',
        '$scope',
        'utilsService',
        '$state',
        '$rootScope',
        function ($window, $scope, utilsService, $state, $rootScope) {
            var ctrl = this;

            ctrl.$onInit = function () {
                $rootScope.$broadcast('getTramiteSeleccionado');
            };

            ctrl.pagoOnline = function () {
                $window.open('https://www.google.com/', '_blank');
            };

            ctrl.verHistorial = function () {
                //$rootScope.$broadcast('esTasaRetributiva', true);
                $state.go('ciudadano.tasashistorico');
            };
        }
    ],
    template: require('./tasasDetalle.html')
});


// WEBPACK FOOTER //
// ./app/components/turnos/tasasRetributivas/tasasDetalleComponent.js